var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingInfo),expression:"loadingInfo"}]},[_c('basic-form',{ref:"stackInfo",attrs:{"title":"Warehouse Info","mode":_vm.FormModes.SPARSE,"form-params":_vm.warehouseInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }